export function paginatorFromResponse(response) {
  const value = response || {};
  return {
    rows: Array.isArray(value.data) ? value.data : [],
    currentPage: Number(value.current_page || 1),
    lastPage: Number(value.last_page || 1),
    perPage: Number(value.per_page || 15),
    total: Number(value.total || 0),
    from: Number(value.from || 0),
    to: Number(value.to || 0),
  };
}

export function apiErrorMessage(error, fallback) {
  const body = error && error.response && error.response.data;
  if (!body) return fallback;
  if (body.errors) {
    const firstKey = Object.keys(body.errors)[0];
    const firstError = firstKey && body.errors[firstKey];
    if (Array.isArray(firstError) && firstError.length) return firstError[0];
    if (typeof firstError === "string") return firstError;
  }
  return body.message || fallback;
}
